export const headerLinks = [
  { title: "Users", to: "/usersHome" },
  { title: "Offices", to: "/officesHome" },
  { title: "Voicemail Stats", to: "/voicemailStats" },
  { title: "Logout", to: "/logout" },
];
